import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { EventData } from '@shared/api/findings/findings-api.types';

interface TraceFindingsState {
  selectedActivity: EventData | null;
}

const initialState: TraceFindingsState = {
  selectedActivity: null,
};

const traceFindingsSlice = createSlice({
  name: 'traceFindings',
  initialState,
  reducers: {
    setSelectedActivity: (state, action: PayloadAction<EventData | null>) => {
      state.selectedActivity = action.payload;
    },
  },
});

export const { setSelectedActivity } = traceFindingsSlice.actions;
export const traceFindingsReducer = traceFindingsSlice.reducer;
